<template>
    <div>
        <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                <div class="d-flex">
                    <div class="page-label">会议id:</div>
                    <div class="page-content">{{ single.meeting_id ? single.meeting_id : '待创建' }}</div>
                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                <div class="d-flex">
                    <div class="page-label">会议时间:</div>
                    <div class="page-content">{{ single.meeting_date }} {{ single.meeting_time }}
                        ({{ single.duration }})
                    </div>
                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                <div class="d-flex">
                    <div class="page-label">密码:</div>
                    <div class="page-content"><b>{{ single.password ? single.password : '无' }}</b> <span
                        v-if="single.zcode"
                        class="text-danger"> | 主持密码:{{ single.zcode }}</span>
                    </div>
                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                <div class="d-flex">
                    <div class="page-label">主持人:</div>
                    <div class="page-content">{{ single.host_id }}({{ single.host_name }}) <span
                        class="text-success"
                        v-if="single.assistant_name"> | {{
                            single.assistant_name
                        }}</span>
                    </div>
                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" v-if="single.assistants">
                <div class="d-flex">
                    <div class="page-label">联席主持:</div>
                    <div class="page-content">{{ single.assistants }}</div>
                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                <div class="d-flex">
                    <div class="page-label">会议室:</div>
                    <div class="page-content">{{ single.room_name_group }}</div>
                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                <div class="d-flex">
                    <div class="page-label">会议选项:</div>
                    <div class="page-content">
                                <span class="meeting-option" v-if="single.waiting_room == '1'">
                                <i class="el-icon-setting"></i> 等候室 </span>
                        <span class="meeting-option" v-if="single.auto_record == '1'">
                                    <i class="el-icon-setting"></i> 自动本地录制 </span>
                        <span class="meeting-option" v-if="single.auto_record == '2'">
                                    <i class="el-icon-setting"></i> 自动云端录制 </span>
                        <span class="meeting-option" v-if="single.option_jbh == '1'">
                                    <i class="el-icon-setting"></i> 提前参会 </span>
                        <span class="meeting-option" v-if="single.option_interpreter == '1'">
                                    <i class="el-icon-setting"></i> 开启同传 </span>
                        <span class="meeting-option" v-if="single.option_live == '1'">
                                    <i class="el-icon-setting"></i> 开启直播 </span>
                        <span class="meeting-option" v-if="single.option_enroll == '1'">
                                    <i class="el-icon-setting"></i> 开启报名 </span>
                        <span class="meeting-option" v-if="single.option_sso_only == '1'">
                                    <i class="el-icon-setting"></i> 内部会议 </span>
                        <span class="meeting-option" v-if="single.option_water_mark == '1'">
                                    <i class="el-icon-setting"></i> 开启水印 </span>
                    </div>
                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" v-if="single.platform == 4">
                <div class="d-flex">
                    <div class="page-label">会议规模:</div>
                    <div class="page-content">
                        {{ single.size }}人
                    </div>
                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                <div class="d-flex">
                    <div class="page-label">用途:</div>
                    <div class="page-content">
                        {{ single.usage }}
                    </div>
                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" v-if="single.label_names">
                <div class="d-flex">
                    <div class="page-label">标签:</div>
                    <div class="page-content">
                        {{ single.label_names }}
                    </div>
                </div>
            </el-col>
        </el-row>
        <div class="clearfix mb-3"></div>
        <el-row :gutter="20" v-if="single.join_url">
            <el-col :span="24">
                <div class="d-flex grey">
                    <div class="page-label">参会链接:</div>
                    <div class="page-content">
                        <el-link :underline="false" class="pull-left mr-3" icon="el-icon-postcard"
                                 @click="$emit('invitation')" type="warning">邀请函
                        </el-link>
                        <el-link :underline="false" class="pull-right ml-3" icon="el-icon-document-copy"
                                 @click="$emit('copy')" type="info">复制信息
                        </el-link>
                        <a :href="single.join_url" target="_blank" style="display: inline"> <i
                            class="el-icon-link"></i> {{ single.join_url }}</a>
                    </div>
                </div>
            </el-col>
            <el-col v-if="single.host_url">
                <div class="d-flex grey">
                    <div class="page-label">{{ $organization.use_label ? '免登入会' : '主持链接' }}:</div>
                    <div class="page-content">
                        <a :href="single.host_url" target="_blank"> <i class="el-icon-link"></i>
                            {{ single.host_url }}</a>
                    </div>
                </div>
            </el-col>
            <el-col v-if="single.streaming">
                <div class="d-flex grey">
                    <div class="page-label">直播链接:</div>
                    <div class="page-content">
                        <a :href="single.streaming" target="_blank"> <i class="el-icon-link"></i>
                            {{ single.streaming }}</a>
                    </div>
                </div>
            </el-col>
        </el-row>
        <div class="clearfix mb-3"></div>
        <el-row :gutter="20">
            <el-col>
                <div class="d-flex" v-if="single.meeting_guests && single.meeting_guests.length">
                    <div class="page-label" style="flex: 0 0 80px;">嘉宾:</div>
                    <div class="page-content" style="overflow: auto;flex: 1;">
                        {{ single.meeting_guests }}
                    </div>
                </div>
            </el-col>
            <el-col v-if="!$organization.use_label">
                <div class="d-flex" v-if="!single.option_enroll ">
                    <div class="page-label" style="flex: 0 0 80px;">参会者:</div>
                    <div class="page-content" style="overflow: auto;flex: 1;">
                        <div v-for="item in emails" :key="item.emails" style="display: inline-block">
                            <el-tooltip effect="light" :content="item.email"
                                        placement="top">
                                <div class="view-attendee-block">
                                    {{ item.name }}
                                    {{ item.over ? ('&lt;' + item.email + '&gt;') : '' }}
                                </div>
                            </el-tooltip>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="page-label" style="flex: 0 0 80px;">报名者:</div>
                    <div class="page-content" style="overflow: auto;flex: 1;">
                        {{ single.enroll_attendees }}
                    </div>
                </div>
            </el-col>

            <el-col class="d-flex" style="flex: 1" v-if="!mobile">
                <div class="page-label">描述:</div>
                <div class="page-content" :style="{minHeight:'31px',maxHeight:'120px',overflow:'auto'}"
                     v-html="single.description"></div>
            </el-col>
            <el-col
                v-if="(single.status == 4 || single.status == 2) && $organization.org != 'sjtu' && single.is_owner">
                <div class="d-flex">
                    <div class="page-label">审批状态:</div>
                    <div class="page-content text-muted">
                        {{ single.status == 4 ? '审批通过' : '审批驳回' }} 于 {{ single.approved_at }}
                        <span v-if="single.approver_name">({{ single.approver_name }})</span>
                    </div>
                </div>
            </el-col>
        </el-row>
        <div class="clearfix mb-3"></div>
        <el-row :gutter="20">
            <div v-if="btn_approve">
                <el-col class="d-flex yellow" style="flex: 1">
                    <div class="page-label">审批:</div>
                    <div class="page-content">
                        <el-form :inline="!mobile" :model="approve_form">
                            <el-form-item label="审批结果" class="mb-0">
                                <el-select size="mini" v-model="approve_form.approve_result"
                                           placeholder="选择审批结果">
                                    <el-option label="暂不处理" value='0'></el-option>
                                    <el-option label="审批驳回" value='1'></el-option>
                                    <el-option label="审批通过" value='2'></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="审批意见" v-show="approve_form.approve_result == '1'"
                                          class="mb-0">
                                <el-input size="mini" v-model="approve_form.reject_reason" clearable
                                          style="width: auto"
                                          placeholder="拒绝，请提出意见"></el-input>
                            </el-form-item>
                            <el-form-item label="" class="mb-0">
                                <el-button type="warning" size="mini" icon="el-icon-s-promotion"
                                           @click="$emit('approve')">提交
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-col>
            </div>
        </el-row>
    </div>
</template>
<script>
export default {
    name: 'meeting-view-general-info',
    props: {
        approve_form: {},
        btn_approve: {},
        emails: {},
        mobile: {},
        single: {}
    }
}
</script>
<style lang="scss">
.page-label {
    flex: 0 0 80px;
    width: 80px;
    text-align: left;
    font-weight: bold;
    display: inline-block;
    line-height: 30px;
    background-color: aliceblue;
    padding: 0 5px;
}

.page-content {
    flex: 1;
    text-align: left;
    margin-left: 10px;
    display: inline-block;
    line-height: 30px;
    border-bottom: solid 1px #b2ebf2;
    overflow: auto;
}
.meeting-option {
}

.view-attendee-block {
    display: inline-block;
    padding: 2px 5px 2px 0;
    transition: all 0.2s ease-in;
    margin-right: 3px;
    cursor: pointer;
    font-weight: bold;
    color: #14a2b8;

    &:hover {
        color: #2196f3;
        text-decoration: underline;
    }
}

</style>
